import React, { useState } from 'react'
import Select from "react-select"
import { ToastContainer, toast } from 'react-toastify'
import { Navigate, useNavigate } from 'react-router-dom'
import '../Video/Addvideo.css'
import { AddSessionApi } from '../../Services/allApi'
function AddSession() {
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        session_name: "",
        session_description: null,
        session_start_date: "",
        session_end_date: null,
        total_no_of_sitting: null,
        total_business_hours: null,
        kla:""
    });

    const klaoptions = [
        { value: 1, label: "KLA 1" },
        { value: 2, label: "KLA 2" },
        { value: 3, label: "KLA 3" },
        { value: 16, label: "KLA 4" }
    ]

    const [selectedOptionKLA, setSelectedOptionKLA] = useState(null)
    // when a value is selected from the option provided in KLA, handelchangekla is called///
    const handlechangekla = (selectedOptionKLA) => {
        //updating both selectedOptionKLA and the VideoDetails state variable with the new kla value.
        setSelectedOptionKLA(selectedOptionKLA)
        setFormData({ ...formData, kla: selectedOptionKLA.value })
    }


    const handleAddSession = async () => {
        var SessionApiResult
        if (!formData.session_name) {
            toast.warning("Session number required")
        }
        else if (!formData.kla) {
            toast.warning("KLA date required")
        }
        else if(!formData.session_start_date){
            toast.warning("Start date required")
        }
        else {
            var token = sessionStorage.getItem('access_token')
            const reqHeader = {
                "Content-Type": "application/json", "Authorization": `${token}`
            }
            console.log(token);
            try {
                SessionApiResult = await AddSessionApi(formData, reqHeader)
                console.log(SessionApiResult);
                if (SessionApiResult.status == 200) {
                    toast.success("Session added successfully")
                }
                else {
                    toast.error("Error while adding Session")
                }
            } catch (err) {
                console.log(err);
                toast.error("There was an error")
            }

        }

        console.log(formData);
    }

    return (

        <div className='w-full h-full flex justify-center' style={{ fontFamily: 'ropa sans' }}>
            <div className='w-9/12  flex flex-col '>
                <div className='flex justify-center '><h2 className='mt-12 md:text-xl text-md'>Add New KLA</h2></div>

                {/* row 1 */}
                <div className='flex flex-row justify-between flex-wrap mt-16'>

                    {/* session number */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="fname">Session No</label>
                        <input value={formData.session_name} onChange={(e) => setFormData({ ...formData, session_name: e.target.value })} type="number" name="" id="fname" className='w-full h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/* total sittings */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                    <label htmlFor="kla">KLA</label>
                
                        <Select
                            id='kla'
                            styles={{
                                //control property is a function that takes in two arguments(baseStyles,state)
                                //baseStyles contains default style for control element
                                // state contains information about current state of control element
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderColor: state.isFocused ? '#384D6C' : '#384D6C',
                                    height: '3rem',
                                    borderRadius: '0.5rem',

                                }),
                            }}
                            className=''
                            options={klaoptions}
                            value={selectedOptionKLA}
                            onChange={handlechangekla} />
                    </div>



                </div>

                {/* row 2 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/*start Date */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="date">Start Date</label>
                        <input value={formData.session_start_date} onChange={(e) => setFormData({ ...formData, session_start_date: e.target.value })} type="date" name="" id="sdate" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    {/*End Date */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="endate">End Date</label>
                        <input value={formData.session_end_date} onChange={(e) => setFormData({ ...formData, session_end_date: e.target.value })} type="date" name="" id="endate" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>



                </div>


                {/* row 3 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/* Total business */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="constituency">Total Business Hours</label>
                        <input value={formData.total_business_hours} onChange={(e) => setFormData({ ...formData, total_business_hours: e.target.value })} type="text" name="" id="constituency" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>


                    {/* description */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="constituency">Description</label>
                        <input value={formData.session_description} onChange={(e) => setFormData({ ...formData, session_description: e.target.value })} type="text" name="" id="constituency" className='dateinput w-fll h-12 rounded-lg ' style={{ border: '1px solid #384D6C' }} />
                    </div>
                </div>


                {/* row 4 */}
                <div className='flex flex-row justify-between flex-wrap'>

                    {/* total sittings */}
                    <div className='mt-6 flex flex-col md:w-5/12 w-full'>
                        <label htmlFor="lname">Total Sittings</label>
                        <input value={formData.total_no_of_sitting} onChange={(e) => setFormData({ ...formData, total_no_of_sitting: e.target.value })} type="text" name="" id="lname" className='w-fll h-12 rounded-lg' style={{ border: '1px solid #384D6C' }} />
                    </div>

                    <div className='mt-6 flex flex-row md:justify-end justify-center md:w-5/12 w-full'>
                        <div className='flex justify-evenly flex-row mt-7'>
                            <button className='h-10 bg-primary w-28 text-white rounded-lg' onClick={handleAddSession}>Save</button>
                            <button className='ms-10 h-10 bg-white w-28 text-primary rounded-lg border-2 hover:bg-blue-200' >Cancel</button>
                        </div>
                    </div>



                </div>

            </div>

            <ToastContainer
                style={{ width: '400px', /* other styles */ }}
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>


    )
}

export default AddSession